import { FormField, getErrors, TextArea } from '@maia/ui';
import { ComponentProps } from 'react';
import { useFieldContext } from '../dynamic-form';

type TextareaFieldProps = Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function TextareaField(props: TextareaFieldProps) {
  const { ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <TextArea
          value={field.state.value}
          onChange={(event) => field.handleChange(event.target.value)}
        />
      }
    />
  );
}
